import { DateField } from '@mi-front/ui';
import { Grid } from '@mui/material';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';
import { MentionIdField } from '../../../../components/MentionIdField';

/**
 * Filter form for mentions schedule status report.
 */
export function ScheduleStatusMentionsForm(_p: object) {
  const { $t } = useIntl();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3} xl={2}>
        <DateField
          name="date"
          label={$t({
            id: 'common.date',
            defaultMessage: 'Fecha',
          })}
          isOutsideRange={(date) => moment(date) > moment()}
        />
      </Grid>
      <Grid item xs={12} md={3} xl={2}>
        <MentionIdField submitOnClear={false} />
      </Grid>
    </Grid>
  );
}
